<template>
    <div id="processManage">
        <my-header></my-header>
        <div class="banner">
            <!--<img src="../../../assets/images/invitemanage/banner01.png"/>-->
            <img src="../../../assets/images/invitemanage/banner08.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ titleData.formTitle }}<span>{{ getNodeName() }}</span></h2>
                    <!--<p>发布时间：{{ titleData.createDate ? titleData.createDate.split(' ')[0] : '' }}</p>-->
                </div>
            </div>
        </div>
        <div class="main-container mainWrap">
            <el-tabs v-model="activeName"  @tab-click="tabsChange">
                <el-tab-pane v-for="(list,index) in horizontalStepList" :label="list.sectionName" :name="''+index" :key="index" class="stepTab">
                    <el-row class="btns">
                        <el-button type="primary" v-show="active == 0 && isPublic == 1 && purchaseType == 0 && littleStatus == 1" @click="toReply">回复邀请函</el-button>
                        <!-- <el-button type="primary" v-show="active == 1 && littleStatus != 0 && purchaseType == 0 && !list.bidStop" @click="toPrequalification">资格预审</el-button> -->
                        <el-button type="primary" v-show="(active == 2 ||active == 3||active == 4) && purchaseType == 0 && !list.bidStop" @click="toDownload(1)"><i class="downloadIcon"></i>下载标书</el-button>
                        <el-button type="primary" v-show="(active == 2 ||active == 3||active == 1) && purchaseType == 1" @click="toDownload(1)"><i class="downloadIcon"></i>下载标书</el-button>
                        <el-button type="primary" v-show="active == 3 && purchaseType == 0 " @click="toQuestions(1)"><i class="problemIcon"></i>质疑/答疑</el-button>
                        <el-button type="primary" v-show="active == 2 && purchaseType == 1" @click="toQuestions(1)"><i class="problemIcon"></i>质疑/答疑</el-button>
                        <el-button type="primary" v-show="active == 4 && list.actionStatus==2 && purchaseType == 0 && !list.bidStop" @click="toBackStandard(list.id,1)"><i class="backStandardIcon"></i>回  标</el-button>
                        <el-button type="primary" v-show="active == 3 && list.actionStatus==2 && purchaseType == 1 && !list.bidStop" @click="toBackStandard(list.id,1)"><i class="backStandardIcon"></i>回  标</el-button>
                        <!-- 嘉福逻辑  -->
                        <!-- <el-button type="primary" v-show="active == 4 && list.actionStatus==4 && purchaseType == 0 && !list.bidStop" @click="toBusinessNegotiation(list.id,1)"><i class="backStandardIcon"></i>商务谈判</el-button>
                        <el-button type="primary" v-show="active == 3 && list.actionStatus==4 && purchaseType == 1 && !list.bidStop" @click="toBusinessNegotiation(list.id,1)"><i class="backStandardIcon"></i>商务谈判</el-button> -->
                        <!-- <el-button type="primary" v-show="active == 3 && ( list.actionStatus == 1) && purchaseType == 1" @click="toBackStandard(list.id,1)"><i class="backStandardIcon"></i>回  标</el-button> -->
                        <el-button type="primary" v-show="active == 4 && ( list.actionStatus == 3) && purchaseType == 0 && showBtn && !list.bidStop" @click="toTender(list.id,1)"><i class="bidReplyIcon"></i>询标回复</el-button>
                        <!-- <el-button type="primary" v-show="active == 4 && ( list.actionStatus == 4) && purchaseType == 0 && !list.bidStop" @click="toBusinessNegotiation(list.id,1)"><i class="backStandardIcon"></i>商务谈判</el-button>
                        <el-button type="primary" v-show="active == 3 && ( list.actionStatus == 2) && purchaseType == 1" @click="toBusinessNegotiation(list.id,1)"><i class="backStandardIcon"></i>商务谈判</el-button>
                        <el-button type="primary" v-show="active == 1 && ( list.actionStatus == 2) && purchaseType == 2" @click="toBusinessNegotiation(list.id,1)"><i class="backStandardIcon"></i>商务谈判</el-button> -->
                        <el-button type="primary" v-show="((active == 4 && ( list.actionStatus >= 3)) || active == 5) && purchaseType == 0 && showBtn && !list.bidStop" @click="toResult">查看询标报价</el-button>
                        <!--<el-button type="primary" v-show="active == 5" @click="toLetter" class="winLetter">中标通知书/感谢信</el-button>-->
                    </el-row>
                    <div class="topSteps">
                        <el-steps
                            v-show="purchaseType == 0"
                            :active="active"
                            :finish-status="status"
                            class="horizontalStep"
                            align-center>
                            <el-step title="公开报名"></el-step>
                            <el-step title="标书下载"></el-step>
                            <el-step title="答疑"></el-step>
                            <el-step title="回标"></el-step>
                            <el-step title="定标"></el-step>
                        </el-steps>
                        <el-steps
                            v-show="purchaseType == 1"
                            :active="active"
                            :finish-status="status"
                            class="horizontalStep2" align-center>
                            <el-step title="标书下载"></el-step>
                            <el-step title="答疑"></el-step>
                            <el-step title="回标"></el-step>
                            <el-step title="定标"></el-step>
                        </el-steps>
                        <el-steps
                            v-show="purchaseType == 2"
                            :active="active"
                            :finish-status="status"
                            class="horizontalStep3" align-center>
                            <el-step title="直委申请"></el-step>
                            <el-step title="商务谈判"></el-step>
                            <el-step title="定标"></el-step>
                        </el-steps>
                    </div>
                    <section class="process">
                        <h2 class="progressTitle">流程进度</h2>
                        <ul class="ownSteps">
                            <li v-for="(item,i) in list.historyComments" :key="i">
                                <div class="dateStep">
                                    <p>{{ item.createDate }}</p>
                                </div>
                                <div class="clockStep">
                                    <img src="../../../assets/images/backStandard/clock.png"/>
                                    <strong class="progress" v-if="item.actionStatus == 2">中止</strong>
                                    <strong class="over" v-else >完成</strong>
                                    <p class="processLine"></p>
                                </div>
                                <div class="textStep" v-if="item.actionStatus == 2">
                                    <h3>{{ item.nodeName }}<a href="javascript:;" class="view" v-if="showView(item)" @click="toView(item,list)">查看</a></h3>
                                    <p>状态：{{ item.actionName}}</p>
                                    <p class="timeT" >中止日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                </div>
                                <div class="textStep" v-else>
                                    <h3>{{ item.nodeName }}<a href="javascript:;" class="view" v-if="showView(item)" @click="toView(item,list)">查看</a></h3>
                                    <p>状态：{{ item.actionName}}</p>
                                    <p class="timeT" v-show="item.modelType == 30 ">直委申请日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 28 ">议标申请日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 26 ">下载日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 19">发标日期：{{  item.updateDate  ?  item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 18">回复日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 29">报名日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 51">资格预审日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 52">质疑日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 53">询标日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 20">回标日期：{{ item.updateDate ? item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 22">商务谈判日期：{{  item.updateDate ?  item.updateDate.split(' ')[0] : '' }}</p>
                                    <p class="timeT" v-show="item.modelType == 24">定标日期：{{  item.updateDate ?  item.updateDate.split(' ')[0] : '' }}</p>
                                </div>
                                <div class="timeStep">
                                    <p v-show="item.modelType == 29">{{ dateData.signDeadline ? '公开报名截止时间：'+dateData.signDeadline : ''}}</p>
                                    <p v-show="item.modelType == 51">{{ dateData.preQualificationResponseDea ? '资格预审回复截止时间：'+dateData.preQualificationResponseDea : ''}}</p>
                                    <p v-show="item.modelType == 22">{{ businessNegotiationResponse ? '商务谈判截止时间：'+businessNegotiationResponse : ''}}</p>
                                    <p v-show=" item.modelType == 52">{{ dateData.queryDeadline ? '质疑截止时间：'+dateData.queryDeadline : ''}}</p>
                                    <p v-show="item.modelType == 53 ">{{ inquiringBidTime ? '询标回复截止时间：'+inquiringBidTime : ''}}</p>
                                    <p v-show="item.modelType == 26 || item.modelType == 20">{{ dateData.returnTenderDeadline ? '回标截止时间：'+ dateData.returnTenderDeadline : ''}}</p>
                                </div>
                            </li>
                        </ul>
                    </section>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../MasterHeader.vue'
    import axios from 'axios'
    export default {
        name: 'master-processManagement',
        data() {
            return {
                activeName: '0',//el-tab-pane的activeName
                active: 0,// steps步骤条
                id: '',//当前的列表项id
                dealId: '',//当前的待办项id
                status: 'success',//结束状态是成功还是失败 还是进行中
                statusList: [],//状态节点名称列表
                littleStatus: '',//小状态，判断按钮的显示隐藏；
                titleData: {},//其他标题
                horizontalStepList: [],//有几个标段，及具体数据
                inquiringBidTime: '',//询标回复截止时间
                businessNegotiationResponse: '',//商务谈判截止时间
                dateData: {
                   /* businessNegoteReturnDelay: '',
                    businessNegoteReturn: '',
                    bidEvaluationDelay: '',
                    bidEvaluation: '',
                    twoRoundBackBidDelay: '',
                    twoRoundBackBid: '',
                    questions: '',
                    answers: '',
                    backBidDelay: '',
                    backBid: ''*/
                },//全部日期
                purchaseType: 0,//采购方式：0 邀请招标，1 直接仪标，2 战略直委
                isPublic: 1,//是否是公开报名 1 非公开 0 公开
                showBtn: true,//是否显示询标 查看开标结果按钮，1 工程类显示，2 营销，0 设计类不显示
            }
        },
        components: {
            MyHeader
        },
        created(){
            this.$root.activeIndex = 'win';
            if(this.$route.params.type == 1){//1 列表进入，2 待办进入
                this.id = this.$route.params.id;
            }else {
                this.dealId = this.$route.params.id;
            }
            this.getStatus();//获取状态节点名称 及初始化数据
        },
        mounted(){},
        methods: {
            tabsChange(tab, event){
                /* 缓存后面的质疑要根据标段质疑用 */
                window.sessionStorage.setItem('sectionId',this.horizontalStepList[this.activeName].id);
                window.sessionStorage.setItem('segmentsNumber',this.horizontalStepList[this.activeName].segmentsNumber);
            },
            getLabel(i){
                if (i == 0){
                    return '标段一';
                } else if(i == 1) {
                    return '标段二';
                } else if(i == 2) {
                    return '标段三';
                }
            },
            getNodeName(){
                if(this.active == 0){
                    let text = '';
                    if(this.purchaseType == 0){
                        text = this.isPublic == 1 ? '回复邀请函' : '公开报名';
                    } else if(this.purchaseType == 1){
                        text = '议标申请';
                    } else if(this.purchaseType == 2){
                        text = '直委申请';
                    }
                    return text;
                } else if(this.active == 1){
                    let text = '';
                    if(this.purchaseType == 0){
                        text = '公开报名';
                    } else if(this.purchaseType == 1){
                        text = '发标';
                    }else if(this.purchaseType == 2){
                        text = '商务谈判';
                    }
                    return text;
                } else if(this.active == 2){
                    let text = '';
                    if(this.purchaseType == 0){
                        text = '标书下载';
                    } else if(this.purchaseType == 1){
                        text = '标书下载';
                    }else if(this.purchaseType == 2){
                        text = '定标';
                    }
                    return text;
                }else if(this.active == 3){
                    let text = '';
                    if(this.purchaseType == 0){
                        text = '标书下载';
                    } else if(this.purchaseType == 1){
                        text = '商务谈判';
                    }else if(this.purchaseType == 2){
                        text = '定标';
                    }
                    return text;
                }  else if(this.active == 4){
                    let text = '';
                    if(this.purchaseType == 0){
                        text = '回标';
                    } else if(this.purchaseType == 1){
                        text = '定标';
                    }
                    return text;
                } else if(this.active >= 5 ){
                    return '定标'
                }
            },
            getStatus(){//获取状态节点名称
                let _this = this;
                _this.$root.getHttp('/v1/sysDict/selectMap?type=tender_management_outer',function (res){
                    _this.statusList = res.data.data;
                    _this.getDetail(_this);
                });
            },
            getDetail(that){//初始化数据
                let url='';
                if(this.$route.params.type == 1){//从列表进入
                    url = '/v1/outerformflow/purchaseItemDetail?id='+ that.id+'&dealId=';
                } else {//从待办进入
                    url = '/v1/outerformflow/purchaseItemDetail?dealId='+that.dealId+'&id=';
                }
                that.$root.getHttp(url,function (res) {
                    that.purchaseType = res.data.data.purchaseType;
                    that.inquiringBidTime = res.data.data.inquiringBidTime;
                    that.businessNegotiationResponse = res.data.data.businessNegotiationResponse;
//                    console.log(res,that.inquiringBidTime,that.businessNegotiationResponse)
                    if(that.purchaseType == 0){//邀请招标情况下
                        that.isPublic = res.data.data.wflowForm.isPublic;
                        that.showBtn = res.data.data.wflowForm.purchaseClassification == 1 ? true : false;//1 工程类 0 设计类 2 营销类
                    }
                    let status = parseInt(res.data.data.flowFormExtMng.flowFormStatus);
                    that.littleStatus = res.data.data.flowFormExtMng.flowFormSubStatus;
                    that.active = status - 1;
                    /*  STATUS_3("标书下载", 3),
                        STATUS_10("公开报名", 10),
                        STATUS_4("回标", 4),
                        STATUS_5("定标", 5),
                        STATUS_11("答疑", 11) */
                    if(that.purchaseType == 0){//邀请招标
                        if(status == 10 ){//9 公开报名
                            that.active = 1;
                        } else if(status == 3){//3 发标
                            that.active = 2;
                        } else if(status == 4){//4 回标
                            that.active = 4;
                        } else if(status == 5){//定标
                            that.active= 5;
                        } else if(status == 13){//答疑
                            that.active= 3;
                        }
                    } else if(that.purchaseType == 1){//直接议标 10 直接议标申请
//                        that.active = status;
                        if(status == 3){//10 直接议标申请
                            that.active = 1;
                        } else if(status == 13){//答疑
                            that.active = 2;
                        }else if(status == 4){//回标
                            that.active = 3;
                        }else if(status == 5){//定标
                            that.active = 4;
                        }
                    } else if(that.purchaseType == 2){//战略直委 12 直委申请
//                        that.active = status;
                        if(status == 12){//12 直委申请
                            that.active = 1;
                        } else if(status == 11){//商务谈判
                            that.active = 1;
                        } else if(status == 5){//定标
                            if(that.littleStatus == 2){//1 待定标，2 已定标
                                that.active = 3;
                            } else {
                                that.active = 2;
                            }
                        }
                    }
                    that.titleData = res.data.data.flowFormExtMng;
                    that.horizontalStepList = res.data.data.flowFormExtSubMngs;
                    window.sessionStorage.setItem('sectionId',that.horizontalStepList[that.activeName].id);
                    window.sessionStorage.setItem('segmentsNumber',that.horizontalStepList[that.activeName].segmentsNumber);
                    that.dateData = res.data.data.wflowForm || {};

                    let elTabHeader = document.getElementsByClassName('el-tabs__header')[0];
                    if(that.purchaseType == 0){//邀请招标
                        /* if(that.active == 5){//回标之前不显示tab的header，隐藏标段,不分标段
                            elTabHeader.style.display = 'none';
                        } else {
                            elTabHeader.style.display = 'block';
                        } */
                    } else if(that.purchaseType == 1){//直接仪标不分标段
                        elTabHeader.style.display = 'none';
                    } else if(that.purchaseType == 2){//战略直委 商务谈判之前不分标段
                        if(that.active < 1){//回标之前不显示tab的header，隐藏标段,不分标段
                            elTabHeader.style.display = 'none';
                        } else {
                            elTabHeader.style.display = 'block';
                        }
                    }
                })
            },
            showView(val){//显示 垂直steps的查看按钮；
                if(val.modelType == 29  || val.modelType == 19 || val.modelType == 24 || val.modelType == 25 || val.modelType == 30 || val.modelType == 28){
                    return false;
                } else {
                    return true;
                }
            },
            toReply(){//回复邀请函
                this.$router.push('/master/replyInvite/'+this.titleData.flowFormId+'/'+1);
            },
            toPrequalification(){//资格预审
                this.$router.push('/master/prequalification/'+this.titleData.flowFormId+'/'+1);
            },
            toDownload(type){//标书下载
                this.$router.push('/master/downloadDoc/'+this.titleData.flowFormId+'/'+1+'/'+this.purchaseType+'/0');
            },
            toQuestions(entrance){//质疑答疑
                this.$router.push('/master/questions/'+this.titleData.flowFormId+'/'+entrance+'/0');
            },
            toBackStandard(id,entrance,type){
//              回标  entrance 入口(1:回标处理入口，2回标历史入口)
                let that = this;
                let obj = {
                    formId: this.titleData.flowFormId,
                    subId: id,
                    entrance: entrance,
                    historyType: type || '',
                    purchaseType: this.purchaseType == 0 ? null : this.purchaseType
                };
                this.$root.postHttp('/v1/outerformflow/backBid/detail',obj,function (res) {
//                    console.log(res)
                    window.sessionStorage.setItem('backStandardData',JSON.stringify(res.data.data));
                    that.$router.push('/master/backStandard/'+that.titleData.flowFormId+'/'+id+'/'+entrance+'/'+that.purchaseType);
                })
            },
            toBusinessNegotiation(id,entrance){//商务谈判
                this.$router.push('/master/businessNegotiation/'+this.titleData.flowFormId+'/'+id+'/'+entrance+'/'+this.purchaseType);
            },
            toTender(id,entrance){//询标
                this.$router.push('/master/replyTender/'+this.titleData.flowFormId+'/'+id+'/'+entrance);
            },
            toResult(){//商务开标结果
                this.$router.push('/master/viewResult/'+this.titleData.flowFormId+'/'+1);
            },
            toLetter(){//中标通知书 感谢信
                this.$router.push('/master/letter/'+this.titleData.flowFormId+'/'+1);
            },
            toView(item,list){
                console.log(888,this.purchaseType)
                if(item.modelType == 18){//回复邀请函
                    this.$router.push('/master/replyInvite/'+this.titleData.flowFormId+'/'+2);
                } else if(item.modelType == 51){//资格预审
                    this.$router.push('/master/prequalification/'+this.titleData.flowFormId+'/'+2);
                } else if(item.modelType == 26){//标书下载
                    this.$router.push('/master/downloadDoc/'+this.titleData.flowFormId+'/'+2+'/'+this.purchaseType+'/0');
                } else if(item.modelType == 20) {//回标
                    this.toBackStandard(list.id,2,item.modelType);
                } else if(item.modelType > 20 && item.modelType <= 23){// 商务谈判
                    this.toBusinessNegotiation(list.id,2);
//                    this.toBusinessNegotiation(list.id,2,item.modelType);
                } else if(item.modelType == 53){//询标
                    this.toTender(list.id,2);
                } else if(item.modelType == 52){//质疑答疑
                    this.toQuestions(2);
                }
            },
        }
    }
</script>
<style lang="scss">
    @import "../../../assets/_var.scss";
    #processManage {
        padding: 80px 0 50px;
        min-height: 85vh;
        background: $--primary-fill-color;
        & .head-top{
            background: #fff;
        }
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .wechat {
                background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        .banner {
            img {
                width: 100%;
                min-width:1300px;
                height: 140px;
            }
            .main-container {
                position: relative;
                .bannerText {
                    position: absolute;
                    left: 0;
                    top: -50px;
                    width: 100%;
                    color: #fff;
                    line-height: 34px;
                    h2 {
                        float: left;
                        font-size: 18px;
                        span {
                            display: inline-block;
                            vertical-align: middle;
                            border: 1px solid #fff;
                            padding: 0 8px;
                            margin-left: 15px;
                            height: 24px;
                            font-size: 14px;
                            line-height: 22px;
                            border-radius: 4px;
                            font-weight: normal;
                            box-sizing: border-box;
                        }
                    }
                    p {
                        float: right;
                        font-size: 14px;
                    }
                }
            }
        }
        .mainWrap {
            position: relative;
            margin-top: 20px;
            .el-tabs__content {
                position: static;
            }
        }
        .btns {
            position: absolute;
            right: 40px;
            top: 10px;
            text-align: left;
            z-index: 2;
            .el-button {
                padding: 8px 5px;
                border-radius: 17px;
                min-width: 100px;
                height: 34px;
                i {
                    display: inline-block;
                    margin-right: 3px;
                    width: 18px;
                    height: 18px;
                    vertical-align: middle;
                }
                .downloadIcon {
                    background: url('../../../assets/images/backStandard/icon01.png') no-repeat;
                }
                .problemIcon {
                    background: url('../../../assets/images/backStandard/icon02.png') no-repeat;
                }
                .backStandardIcon {
                    background: url('../../../assets/images/backStandard/icon03.png') no-repeat;
                }
                .bidReplyIcon {
                    background: url('../../../assets/images/backStandard/icon04.png') no-repeat;
                }
            }
            .winLetter {
                padding: 8px 10px;
            }
        }
        /*流程进度*/
        .process {
            width: 1100px;
            margin: 0 auto;
        }
        .progressTitle {//进度标题
            text-align: left;
            line-height: 58px;
            text-indent: 18px;
            background: $--primary-fill-color;
        }
        /*自己写的进度条，垂直方向*/
        .ownSteps {
            margin: 30px 0 50px;
              li {
                  overflow: hidden;
                  padding: 0 20px;
                  /*padding: 10px 20px 15px;*/
                  min-height: 94px;
                  box-sizing: border-box;
                  text-align: left;
                  &>div {
                      /*float: left;*/
                      display: inline-block;
                      vertical-align: middle;
                  }
                  & .dateStep {
                      font-size: 14px;
                      color:$--text-color-lighter;
                      p {
                          width: 78px;
                          white-space: normal;
                          word-break: break-all;
                          line-height: 26px;
                      }
                  }
                  & .clockStep {
                      position: relative;
                      img {
                          vertical-align: middle;
                          width: 38px;
                          height: 38px;
                      }
                      strong {
                          display: inline-block;
                          vertical-align: middle;
                          width: 72px;
                          height: 34px;
                          font-size: 14px;
                          text-align: center;
                          color: #fff;
                          font-weight: 400;
                          line-height: 34px;
                      }
                      .over {
                          background: url('../../../assets/images/backStandard/1.png') no-repeat;
                      }
                      .progress {
                          background: url('../../../assets/images/backStandard/2.png') no-repeat;
                      }
                      .processLine {
                          margin-left: 19px;
                          margin-top: -2px;
                          width: 3px;
                          height: 60px;
                          background: $--secondary-fill-color;
                      }
                  }
                  & .textStep {
                      /*vertical-align: top;*/
                      margin-left: 10px;
                      width: 328px;
                      h3 {
                          font-size: 16px;
                          line-height: 26px;
                          .view {
                              margin-left: 8px;
                              padding: 0 8px;
                              font-size: 12px;
                              color: #fff;
                              background: #4087e0;
                              border-radius: 12px;
                              line-height: 24px;
                              font-weight: normal;
                              text-decoration: none;
                          }
                      }
                      p {
                          font-size: 14px;
                          line-height: 24px;
                      }
                      .timeT {
                          color: $--text-color-lighter;
                      }
                  }
                  & .timeStep {
                      margin-bottom: 10px;
                      vertical-align: bottom;
                      font-size: 14px;
                      color: $--text-color-lighter;
                      line-height: 24px;
                  }
              }
            li:nth-of-type(even){
                background: $--primary-fill-color;
            }
            li:nth-of-type(odd){
                background: #fff;
            }
          }
        .el-tabs {
            background: #fff;
            /*padding-top: 20px;*/
            & .el-tabs__header {
                margin: 0 0 10px;
            }
            & .el-tabs__nav {
                margin-left: 40px;
            }
            & .el-tabs__item {
                font-size: 14px;
                height: 50px;
            }
            & .el-tabs__item.is-active {
                color: $--text-color;
                font-weight: 700;
            }
            & .el-tabs__active-bar {
                bottom: -2px;
                height: 12px;
                background: url('../../../assets/images/register/at.png') no-repeat center 0;
            }
            & .el-tabs__nav-wrap::after {
                height: 1px;
                background-color: $--secondary-fill-color;
            }
        }
        .stepTab{
            .topSteps {
                width: 1200px;
                min-width: 1200px;
            }
             .horizontalStep,
             .horizontalStep2,
             .horizontalStep3{
                margin: 50px auto;
                .el-step__title {
                    font-size: 14px;
                }
            }
            .horizontalStep .el-step {
                width: 16.6667%;
            }
            .horizontalStep2 .el-step {
                width: 20%;
            }
            .horizontalStep3 .el-step {
                width: 33.3%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/ProcessManage.vue